import { useQuery } from "@tanstack/react-query";
import { fetchSubstanceSafety } from "@/services/substance_api";
import type { SubstanceKind } from "@/utils/types/substance";

export function useSubstanceSafety(
  kind: SubstanceKind | null,
  id: number | null,
) {
  return useQuery({
    queryKey: ["substanceSafety", kind, id] as const,
    queryFn: ({ signal }) => fetchSubstanceSafety(kind!, id!, signal),
    enabled: kind !== null && id !== null,
    // Safety data is essentially static reference data.
    staleTime: 5 * 60_000,
  });
}
